import { colors } from 'components/styles/variables';

export default function Separator(): JSX.Element {
  return (
    <>
      <hr className="separator" />
      <style jsx>
        {`
          .separator {
            margin: 0;
            border-bottom: 2px solid ${colors.G1};
            padding-top: 0;
            width: 25%;
            border-top: none;
            border-left: none;
          }
        `}
      </style>
    </>
  );
}
